module.exports = __webpack_public_path__ + "static/media/gerami_logo_s.7cb49d3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/websitesAndProjects/gerami_logo_s.jpg
// module id = 90
// module chunks = 0